export function lsGet (key) {
  const item = localStorage.getItem(key)

  try {
    return JSON.parse(item)
  } catch (e) {
    return item
  }
}

export function lsSave (key, payload) {
  localStorage.setItem(key, JSON.stringify(payload))
}

export function lsRemove (key) {
  localStorage.removeItem(key)
}

export function lsRemoveAll () {
  const allStorageKeys = Object.keys(localStorage)
  allStorageKeys.forEach(key => {
    if (key.indexOf('sc_') > -1) {
      localStorage.removeItem(key)
    }
  })
}
